var fn = function( obj ){
var __t,__p='';
__p+='\nvarying vec2 vTexCoord;\nuniform vec3 uTimeRevealUVScale;\n\nvoid main(void){\n\n  float t = clamp(1.0 - abs(uTimeRevealUVScale.x - (vTexCoord.y * uTimeRevealUVScale.z)) * 15.0, 0.0, 1.0);\n\n  float a1 = (1.0 - abs(vTexCoord.x - 0.5) * 10.0);\n  float a2 = clamp(smoothstep(0.0, 0.01, t) , 0.0, 1.0);\n\n  gl_FragColor = vec4(1.0, 1.0, 1.0, clamp(a1 + a2, 0.0, 1.0) * uTimeRevealUVScale.y);\n  \n}';
return __p;
};
fn.toString=fn;
module.exports = fn;